<template>
  <nav
    class="top-0 z-30 bg-white border-b border-[#C7E4FF] top-nav"
    :class="[headerClass ? 'lg:block' : 'lg:sticky ease-in duration-500']"
  >
    <div class=" bg-primary rounded-b-xl sm:rounded-none top-div">
      <div class="max-w-screen-xl mx-auto px-4 py-2">
        <TsRow class="bg-primary items-center justify-between flex-wrap">
          <Logo />
          <AutoComplete />

          <TsColumn
            dataTestid="column-selectbox"
            class="order-2 lg:order-3 flex grow-0 lg:py-0"
          >
            <TsRow
              append-class="items-center justify-end gap-2 sm:gap-6 text-idle-white py-0"
            >
              <!-- <LanguageSelector /> -->
              <SaveList dataTestid="header-save-list" />
              <Auth data-testid="header-auth" />
              <Cart />
              <MobileHamburger />
            </TsRow>
          </TsColumn>
        </TsRow>
      </div>
    </div>
  </nav>
</template>
<script setup lang="ts">
// Track component mount state to prevent operations after unmount
const isMounted = ref(false);

// Safely access composables with error handling
let locale = ref("nl-NL");
let i18nHead = ref({ value: { link: [], meta: [] } });
let runtimeConfig = null;
let nuxtApp = null;
const headerClass = ref(true);
let lastScrollY = 0;

// Safely initialize composables
try {
  nuxtApp = useNuxtApp();
  locale.value = nuxtApp.$i18n.locale.value;
  runtimeConfig = useRuntimeConfig();
  i18nHead = useLocaleHead();
} catch (error) {
  console.error("Error initializing composables in TsMainHeader:", error);
  // Provide fallback values for testing environment
}

// Only set up head if we're in a normal environment
if (nuxtApp) {
  try {
    useHead(() => ({
      htmlAttrs: {
        lang: locale.value.split("-")[0], // Dynamically set the lang based on state
      },
      link: [...(i18nHead.value.link || [])],
      meta: [...(i18nHead.value.meta || [])],
    }));
  } catch (error) {
    console.error("Error setting up useHead in TsMainHeader:", error);
  }
}

// Define async components with error handling and proper loading states
const Logo = defineAsyncComponent({
  loader: () => import("~/components/header/Logo.vue"),
  errorComponent: {
    template: "<div>Error loading Logo component</div>",
  },
  delay: 200,
  timeout: 5000,
  suspensible: false,
});

const AutoComplete = defineAsyncComponent({
  loader: () => import("~/components/header/AutoComplete.vue"),
  errorComponent: {
    template: "<div>Error loading AutoComplete component</div>",
  },
  delay: 200,
  timeout: 5000,
  suspensible: false,
});

/*
const LanguageSelector = defineAsyncComponent({
  loader: () => import("~/components/header/LanguageSelector.vue"),
  errorComponent: {
    template: "<div>Error loading LanguageSelector component</div>",
  },
  delay: 200,
  timeout: 5000,
  suspensible: false,
});
*/

const SaveList = defineAsyncComponent({
  loader: () => import("~/components/header/SaveList.vue"),
  errorComponent: {
    template: "<div>Error loading SaveList component</div>",
  },
  delay: 200,
  timeout: 5000,
  suspensible: false,
});

const Auth = defineAsyncComponent({
  loader: () => import("~/components/header/Auth.vue"),
  errorComponent: {
    template: "<div>Error loading Auth component</div>",
  },
  delay: 200,
  timeout: 5000,
  suspensible: false,
});

const Cart = defineAsyncComponent({
  loader: () => import("~/components/header/Cart.vue"),
  errorComponent: {
    template: "<div>Error loading Cart component</div>",
  },
  delay: 200,
  timeout: 5000,
  suspensible: false,
});

const MobileHamburger = defineAsyncComponent({
  loader: () => import("~/components/header/MobileHamburger.vue"),
  errorComponent: {
    template: "<div>Error loading MobileHamburger component</div>",
  },
  delay: 200,
  timeout: 5000,
  suspensible: false,
});

onMounted(() => {
  isMounted.value = true;

  if (import.meta.client) {
    Promise.all([
      import("~/components/header/Logo.vue"),
      import("~/components/header/AutoComplete.vue"),
      import("~/components/header/Cart.vue"),
    ]).catch((error) => {
      console.error("Error prefetching components:", error);
    });
    window.addEventListener("scroll", handleScroll);
  }
});

onBeforeUnmount(() => {
  isMounted.value = false;
  window.removeEventListener("scroll", handleScroll);
});

function handleScroll() {
  const currentScrollY = window.scrollY;
  if (currentScrollY > lastScrollY && currentScrollY > 0) {
    headerClass.value = true
  } else {
    headerClass.value = false;
  }
  lastScrollY = currentScrollY;
}
</script>
